import { render, staticRenderFns } from "./FeedbackProvider.vue?vue&type=template&id=8283cebe&"
import script from "./FeedbackProvider.vue?vue&type=script&lang=ts&"
export * from "./FeedbackProvider.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackProvider.vue?vue&type=style&index=0&id=8283cebe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports